import { useDidUpdateEffect } from "@citychallenge/core";
import { FC, useRef } from "react";
import { useLocation } from "react-router-dom";

import { WEB_CONFIG } from "../../core/web-config";
import styles from "./full-ui.module.scss";

export interface FullUIProps {
  header?: React.ReactNode;
  topBar?: React.ReactNode;
}

export const FullUI: FC<FullUIProps> = ({ topBar, children }) => {
  const location = useLocation();
  const mainColumnRef = useRef<HTMLDivElement>(null);

  const isMapBased = WEB_CONFIG.DIVISION_INFO?.mapBased;

  useDidUpdateEffect(() => {
    if (mainColumnRef.current) {
      mainColumnRef.current.scrollTop = 0;
    }
  }, [location]);

  return (
    <div
      className={styles.wrapper}
      data-map-based={isMapBased ? "" : undefined}
    >
      <div className={styles.topBar}>{topBar}</div>
      <div className={styles.mainColumn} ref={mainColumnRef}>
        {children}
      </div>
    </div>
  );
};
